export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23">
    <g fill="none">
      <path
        d="M.5 9.5V20c0 1.4 1.1 2.5 2.5 2.5h14c1.4 0 2.5-1.1 2.5-2.5V9.5H.5z"
        stroke="#979797"
      />
      <path
        d="M16 3h1c1.7 0 3 1.3 3 3v4H0V6c0-1.7 1.3-3 3-3h1v3c0 .6.4 1 1 1s1-.4 1-1V3h8v3c0 .6.4 1 1 1s1-.4 1-1V3z"
        stroke="none"
        fill="#979797"
      />
      <rect x="4.5" y=".5" width="1" height="6" rx=".5" stroke="none" fill="#9b9b9b" />
      <rect x="14.5" y=".5" width="1" height="6" rx=".5" stroke="none" fill="#9b9b9b" />
      <rect x="6" y="12" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="9" y="12" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="12" y="12" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="15" y="12" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="3" y="15" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="6" y="15" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="9" y="15" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="12" y="15" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="15" y="15" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="3" y="18" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="6" y="18" width="2" height="2" stroke="none" fill="#979797" />
      <rect x="9" y="18" width="2" height="2" stroke="none" fill="#979797" />
    </g>
  </svg>
);
